import { useEffect, useRef, forwardRef, useImperativeHandle } from 'react';
import cornerstone from 'cornerstone-core';
import './CornerstoneViewport.css';

const CornerstoneViewport = forwardRef(({ 
    width = '100%', 
    height = '512px',
    onWheel,
    style = {}
}, ref) => {
    const viewportRef = useRef(null);

    useImperativeHandle(ref, () => viewportRef.current);

    useEffect(() => {
        const el = viewportRef.current;
        if (el) {
            try {
                el.style.position = 'relative';
                el.style.touchAction = 'none';
                cornerstone.enable(el);
            } catch { }
        }

        return () => {
            try { 
                if (el) cornerstone.disable(el); 
            } catch (e) {}
        };
    }, []);

    useEffect(() => {
        const el = viewportRef.current;
        if (!el || !onWheel) return;

        const wheelHandler = (e) => {
            e.preventDefault();
            onWheel(e);
        };

        el.addEventListener('wheel', wheelHandler, { passive: false });
        return () => { 
            try { 
                el.removeEventListener('wheel', wheelHandler); 
            } catch (e) {} 
        };
    }, [onWheel]);

    return (
        <div
            ref={viewportRef}
            className="cornerstone-viewport"
            style={{ width, height, ...style }}
        />
    );
});

CornerstoneViewport.displayName = 'CornerstoneViewport';

export default CornerstoneViewport;
